import { CommonData } from "../../../datastructures/gamestate/gameData";
import { replaceUnderscoresWithSpaces } from "../../../functions/Functions_General";
export class EmulationToggleBtn {
  private parent = new PIXI.Container();
  private parentClose = new PIXI.Container();

  private btnClose = new PIXI.Graphics
  ()
    .beginFill(0xff0055,.5).lineStyle(2,0xffffff,0,1)
    .drawRoundedRect(0, 0, 600, 100,12)
    .endFill();
  private labelClose = new PIXI.Text();


  private activeGameData:CommonData;
  constructor(parent: PIXI.Container,activeGameData:CommonData ) {
    parent.addChild(this.parent);
    parent.addChild(this.parentClose);
    this.activeGameData=activeGameData;
    this.parentClose.addChild(this.btnClose);
    let bodyTextStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 35,
      lineHeight: 30,
      fill: ["#ffffff"],
      // wordWrap: true,
      // wordWrapWidth: 500,
      align: "center",
    });



    this.labelClose = new PIXI.Text("◆ "+activeGameData.gameTextGeneral.CLOSE+" ◆",bodyTextStyle);
    this.labelClose.anchor.set(.5);
    this.labelClose.y=this.btnClose.height/2;
    this.labelClose.x=this.btnClose.width/2;
    this.parentClose.addChild(this.labelClose);

    //set onCLikcFunction:

    this.btnClose.on('pointertap', () => {
      this.activeGameData.emulationMode.toggleEmulationMenu();
    });
    //--set position
    //--enable btn by default;
    this.enableBtnMode(true);
    this.labelClose.scale.set(0);
    this.btnClose.scale.set(0);


  }

  public setLabelClose=(bool:boolean):void=>
  { 
 
    if(bool)
    {
      this.labelClose.scale.set(1);
      this.btnClose.scale.set(1);
    }
    else
    {

      this.labelClose.scale.set(0);
      this.btnClose.scale.set(0);
    
    }
  }
 public setPositionMenu=(posx:number,posy:number):void=>
 {
  this.parent.x=posx;
  this.parent.y=posy;
 }

 public setPositionClose=(posx:number,posy:number):void=>
 {
  this.parentClose.x=posx;
  this.parentClose.y=posy;
 }
  
  public enableBtnMode=(bool:boolean):void=>
  {
    this.btnClose.interactive=bool;
    this.btnClose.buttonMode=bool;
    this.btnClose.tint=bool?0xffffff:0x000000;
  }
}


export class EmulationBtn {
    private parent = new PIXI.Container();
    private btnShape = 
    // new PIXI.Sprite(PIXI.Texture.fromFrame('jackpot_txt_bg_large.png'))
     new PIXI.Graphics
    ()
      .beginFill(0x000000,.15).lineStyle(3,0xffffff,1,.65)
      .drawRoundedRect(0, 0, 600, 70,12)
      .endFill();
    private btnLabel = new PIXI.Text();
    private index: number;
    private activeGameData:CommonData;
    
    private isWaitingResponse:boolean=false;
    constructor(parent: PIXI.Container,activeGameData:CommonData ,btnLabel: string, i: number) {
      parent.addChild(this.parent);
      this.activeGameData=activeGameData;
      this.index = i;
      this.parent.addChild(this.btnShape);
      let bodyTextStyle = new PIXI.TextStyle({
        fontFamily: activeGameData.gameTextStyle.gameFont,
        fontSize: 35,
        lineHeight: 30,
        fill: ["#ffffff"],
        // wordWrap: true,
        // wordWrapWidth: 500,
        align: "center",
      });
  
      this.btnLabel = new PIXI.Text("◆ "+replaceUnderscoresWithSpaces(btnLabel),bodyTextStyle);
      this.btnLabel.anchor.set(0,.5);
      this.btnLabel.y=35;
      this.btnLabel.x=35;
      this.parent.addChild(this.btnLabel);
  
      //set onCLikcFunction:
      this.btnShape.on('pointertap', () => {

        if(this.isWaitingResponse===false)
        {
    // this.activeGameData.replay.goToIndexEmulation(this.index);
    this.activeGameData.emulationMode.selectFeatureByIndex(this.index);
        }
      
      });
      
      //--set position
      this.parent.y = this.index * 80+3;
      //--enable btn by default;
      this.enableBtnMode(true);
  
    }
    public setIsWatingResponse=(bool:boolean):void=>
    {
      this.isWaitingResponse=bool;
    }
    public setPosition=(pos:{x:number,y:number}):void=>
    {
      this.parent.position.set(pos.x,pos.y);
    }

    
    public enableBtnMode=(bool:boolean):void=>
    {
      // console.log('btnClickabble---',bool)
      this.btnShape.interactive=bool;
      this.btnShape.buttonMode=bool;
    }
    public setVisible=(bool:boolean):void=>
    {
      this.parent.alpha=bool?1:0;
    }
  }
  
  
  